export interface BasicDetailsState {
    courseId?: string;
    name: string;
    email: string;
    phone: string;
    gender: string;
    address: string;
    accommodationRequired: boolean;
    feeCategory: string;
}

export interface EducationalDetailsState {
    qualifications: Array<{
        highestEducation: string;
        fieldOfStudy: string;
        institutionName: string;
        yearOfCompletion: string;
        certificate: any;
    }>;
}

export interface ProfessionalDetailsState {
    currentOrganisation: string;
    designation: string;
    workExperience: string;
    document: any;
}

export interface StudentRegistrationState {
    basicDetails: BasicDetailsState;
    educationalDetails: EducationalDetailsState;
    professionalDetails: ProfessionalDetailsState;
    currentStep: number;
    completedSteps: number[];
    isSubmitted: boolean;
    isLoading: boolean;
    error: string | null;
}

export const initialState: StudentRegistrationState = {
    basicDetails: {
        courseId: '',
        name: '',
        email: '',
        phone: '',
        gender: '',
        address: '',
        accommodationRequired: false,
        feeCategory: '',
    },
    educationalDetails: {
        qualifications: [],
    },
    professionalDetails: {
        currentOrganisation: '',
        designation: '',
        workExperience: '',
        document: null,
    },
    currentStep: 1,
    completedSteps: [],
    isSubmitted: false,
    isLoading: false,
    error: null,
};
